import { LayoutType } from './layout-type';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ProductFlowConfig, FlowElementPage, FlowElement, ProductFlowService } from 'app/infrastructure/services/productFlow.service';
import { RuleAttribute, PageNavigationAttribute } from './designer-attribute-type';

export class ProductType {
    id: number;
    guid: string;
    codSistema: string;
    codNegocio: string;
    codProducto: string;
    codServicio: string;
    codComando: string;
    documentKind: string;
    standardkey: string;
    name: string;
    comment: string;
    layout: LayoutType;
    currentVersion: any;
    latestVersion: any;
    versionActual: number;
    ultimaVersion: number;
    pageName: string;
    listPath: string;
    pathElements: string[];

    // null aand empty by construction
    pageList: DesignerSelectItem[] = [];
    flowList: any;
    interactionRules: DesignerSelectItem[] = [];
    pgCodes: DesignerSelectItem[]=[];

    attributeCodes: DesignerSelectItem[];

    constructor(listPath: string) {
        this.layout = new LayoutType();
        this.id = 0;

        this.listPath = listPath;
        this.pathElements = this.listPath.split('|');
    }

    // Its a place holder
    loadFlowConfiguration() {
    }

}

export class PageType {
    codSistema: string;
    codNegocio: string;
    codProducto: string;
    codServicio: string;
    codComando: string;
    documentKind: string;
    standardkey: string;
    name: string;
    id: string;
    flowId: string;
    layout: LayoutType;

    listPath: string;
    pathElements: string[];

    // loaded at start
    pageList: DesignerSelectItem[];
    flowList: any;
    interactionRules: DesignerSelectItem[];

    attributeCodes: DesignerSelectItem[];
    pgCodes: DesignerSelectItem[];

    constructor(flowId: string, id: string, listPath: string) {
        this.layout = new LayoutType();
        this.id = id;
        this.flowId = flowId;
        this.listPath = listPath;
    }

}
export interface DesignerSelectItem
{
 id: string;
 description: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/types/product.type.ts